import Web3 from "web3";
import { Decimal } from "decimal.js";
import WalletConnectProvider from "@walletconnect/web3-provider";

//1=eth 56=bsc 43114=avax 137=matic 250=ftm 1313161554=aurora 288=boba 25=cro 42262=oasis 10000=smarbch 1284=moonbeam
const walletConnectProvider = new WalletConnectProvider({
    rpc: {
        1: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
        56: "https://bsc-dataseed.binance.org/",
        43114: "https://rpc.ankr.com/avalanche",
        137: "https://polygon-rpc.com",
        250: "https://rpc.ftm.tools/",
        1313161554: "https://mainnet.aurora.dev",
        288: "https://mainnet.boba.network",
        25: "https://evm-cronos.crypto.org",
        42262: "https://emerald.oasis.dev",
        10000: "https://smartbch.greyh.at",
        1284: "https://rpc.api.moonbeam.network",
        4: "https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
    }
});

const state = () => ({
    // network & token state
    chainId: null, //default chain id is eth, so if not connected then vaults still show on home or vault page
    selectedToken: null,
    selectedNetwork: "eth",
    tokenText: null,
    currentNetwork: null, //all config abi and decimal for current network
    // wallet state
    hasWallet: false,
    walletProvider: null, //metamask / walletconnect
    disconnectingWalletConnect: false,
    activeWeb3: null,
    checkMetamask: false,
    balance: null,
    address: null,
    slicedAddress: null,
    tokens: [],
    baseBalance: null
});

const getters = {
    getChainId: state => state.chainId,
    getSelectedToken: state => state.selectedToken,
    getSelectedNetwork: state => state.selectedNetwork,
    getTokenText: state => state.tokenText,
    getCurrentNetwork: state => state.currentNetwork,

    getHasWallet: state => state.hasWallet,
    getWalletProvider: state => state.walletProvider,
    getDisconnectingWalletConnect: state => state.disconnectingWalletConnect,
    getActiveWeb3: state => state.activeWeb3,
    getCheckMetamask: state => state.checkMetamask,
    getBalance: state => state.balance,
    getAddress: state => state.address,
    getSlicedAddress: state => state.slicedAddress
};

const actions = {
    changeNetwork(context, chainId) {
        this.commit("wallet/setChainId", chainId);
        const network = this.state.vaults.env.network;
        for (const key in network) {
            const element = network[key];
            if (element.chain == chainId) {
                this.commit("wallet/setCurrentNetwork", element);
                this.commit("wallet/setSelectedNetwork", {
                    selectedTokenText: element.token,
                    selectedNetwork: key
                });
            }
        }
    },

    getNetworkAbi(context) {
        const tokens = [];
        const networks = this.state.vaults.env.network;
        for (const key in networks) {
            const element = networks[key];
            for (let i = 0; i < element.tokens.length; i++) {
                const e = element.tokens[i];
                e.abi = JSON.parse(e.abi);
                e.network = key;
                tokens.push(e);
            }
        }
        this.commit("wallet/setTokens", tokens);
    },

    async checkChainId(context) {
        try {
            if (context.state.walletProvider == "metamask") {
                const chainId = await ethereum.request({
                    method: "eth_chainId"
                });
                return chainId;
            } else if (context.state.walletProvider == "walletconnect") {
                const chainId = await context.state.activeWeb3.eth.getChainId();
                return "0x" + chainId.toString(16);
            } else {
                return null;
            }
        } catch (error) {
            console.log(error);
        }
    },

    async clearWalletStatus(context) {
        try {
            if(context.state.walletProvider == "walletconnect") {
                Vue.default.toasted.info(
                    "Please refresh page before connecting to Wallet Connect.",
                    { duration: 2500 }
                );
            }
            this.commit("wallet/setHasWallet", false);
            this.commit("wallet/setAddress", null);
            this.commit("wallet/setBalance", null);
            this.commit("wallet/setBaseBalance", null);
            this.commit("wallet/setWalletProvider", null);
            localStorage.removeItem("WALLETCONNECT_DEEPLINK_CHOICE");
            localStorage.removeItem("walletconnect");

            if (!context.state.disconnectingWalletConnect && walletConnectProvider.connected) {
                this.commit("wallet/setDisconnectingWalletConnect", true);
                await walletConnectProvider.close();
                setTimeout(() => {
                    this.commit("wallet/setDisconnectingWalletConnect", false);
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async checkWalletStatus(context) {
        try {
            // if metamask not detected
            if (typeof window.ethereum === "undefined") {
                this.commit("wallet/setCheckMetamask", false);
                // if last state connected with metamask & metamask disabled
                if (localStorage.walletProvider == "metamask") {
                    this.dispatch("wallet/clearWalletStatus");
                }
            } else {
                this.commit("wallet/setCheckMetamask", true);
            }

            // get local storage to get last wallet provider
            if (localStorage.hasWallet && localStorage.walletProvider) {
                this.commit("wallet/setHasWallet", localStorage.hasWallet);
                this.commit(
                    "wallet/setWalletProvider",
                    localStorage.walletProvider
                );
            }

            if (!context.state.walletProvider) {
                this.dispatch("wallet/clearWalletStatus");
                return;
            }

            if(context.state.walletProvider == "walletconnect") {
                if(!localStorage.walletconnect) {
                    this.dispatch("wallet/clearWalletStatus");
                    return;
                }
                const resp = await walletConnectProvider.enable();
                console.log(resp);
            }
            const chainId = await this.dispatch("wallet/checkChainId");
            this.dispatch("wallet/changeNetwork", chainId);
            await this.dispatch("wallet/loadAccount", chainId);
        } catch (error) {
            console.log(error);
        }
    },

    async connectWithMetamask({ context, state }) {
        if (typeof window.ethereum === "undefined") {
            Vue.default.toasted.error(
                "Please install MetaMask first."
            );
            return;
        }

        try {
            const accounts = await ethereum.request({
                method: "eth_requestAccounts"
            });

            this.commit("wallet/setWalletProvider", "metamask");
            const chainId = await this.dispatch("wallet/checkChainId");
            await this.dispatch("wallet/loadAccount", chainId);
        } catch (error) {
            // User rejected request
            if (error.code === 4001) {
                Vue.default.toasted.error("MetaMask request rejected.");
            } else if (error.code === -32002) {
                Vue.default.toasted.error(
                    "Please approve the request on MetaMask first."
                );
            }
            return;
        }
    },

    async connectWithWalletConnect({ commit, dispatch, state }) {
        try {
            const resp = await walletConnectProvider.enable();
            console.log(resp);
            if(walletConnectProvider.connected) {
                this.commit("wallet/setWalletProvider", "walletconnect");
                const chainId = await this.dispatch("wallet/checkChainId");
                await this.dispatch("wallet/loadAccount", chainId);
            } else {
                throw new Error("Can't connect to the wallet provider.");
            }
        } catch (ex) {
            console.log(ex.message);
            if (ex.message == "User closed modal") {
                // force refresh page, because wallet connect btn will not working after user reject the qr pop up
                window.location.reload();
            }
        }
    },

    async accountChanged({ context, state }, account) {
        const chainId = await this.dispatch("wallet/checkChainId");
        await this.dispatch("wallet/loadAccount", chainId);
    },

    async chainChanged({ context, state }, chainId) {
        this.dispatch("wallet/changeNetwork", chainId);
        await this.dispatch("wallet/loadAccount", chainId);
    },

    async getAccounts(context) {
        try {
            if (context.state.walletProvider == "metamask") {
                return await ethereum.request({ method: "eth_accounts" });
            } else if (context.state.walletProvider == "walletconnect") {
                return await context.state.activeWeb3.eth.getAccounts();
            } else {
                return false;
            }
        } catch (error) {
            console.log(error);
        }
    },

    async getBalance(context, account) {
        try {
            if (context.state.walletProvider == "metamask") {
                return await ethereum.request({
                    method: "eth_getBalance",
                    params: [account, "latest"]
                });
            } else if (context.state.walletProvider == "walletconnect") {
                return await context.state.activeWeb3.eth.getBalance(account);
            } else {
                return false;
            }
        } catch (error) {
            console.log(error);
        }
    },

    async loadAccount(context, chainId) {
        try {
            const ShowAccount = await this.dispatch("wallet/getAccounts");

            if (ShowAccount.length === 0 || !ShowAccount) {
                this.dispatch("wallet/clearWalletStatus");
                return;
            } else {
                // check if allowed network
                let allowedNetwork = await this.dispatch(
                    "vaults/isAllowedNetwork",
                    chainId
                );

                if (!allowedNetwork) {
                    // then empty all localstorage and set vuex to false and null
                    this.dispatch("wallet/clearWalletStatus");
                    this.commit("vaults/setShowNetworkAlert", true);
                    return;
                }

                this.commit("wallet/setHasWallet", true);
                this.commit("wallet/setAddress", ShowAccount[0]);
                this.dispatch("wallet/changeNetwork", chainId);

                const Balance = await this.dispatch(
                    "wallet/getBalance",
                    ShowAccount[0]
                );
                Decimal.set({ precision: 50, defaults: true });

                this.commit(
                    "wallet/setBaseBalance",
                    new Decimal(Balance).dividedBy(1e18).toString()
                );
            }
        } catch (error) {
            console.log(error);
        }
    },

    async initEvent(context) {
        const handleAccountChanged = accounts => {
            if (accounts || accounts.length) {
                this.dispatch("wallet/accountChanged", accounts);
            } else {
                this.dispatch("wallet/clearWalletStatus");
            }
        };

        const handleChainChanged = chainId => {
            let newChainId = chainId;
            if (typeof chainId === "number") newChainId = "0x" + chainId.toString(16);
            this.dispatch("wallet/chainChanged", newChainId);
        };

        const handleDisconnected = () => {
            this.dispatch("wallet/clearWalletStatus");
        };

        if (typeof window.ethereum !== "undefined") {
            ethereum.on("accountsChanged", (accounts) => {
                if (context.state.walletProvider == "metamask") handleAccountChanged(accounts);
            });
            ethereum.on("chainChanged", (chainId) => {
                if (context.state.walletProvider == "metamask") handleChainChanged(chainId);
            });
        }

        // walletConnectProvider.on("accountsChanged", (accounts) => {
        //     if (context.walletProvider == "walletconnect") handleAccountChanged(accounts);
        // });
        walletConnectProvider.on("chainChanged", (chainId) => {
            if (context.state.walletProvider == "walletconnect") handleChainChanged(chainId);
        });
        walletConnectProvider.on("disconnect", () => {
            if (context.state.walletProvider == "walletconnect") handleDisconnected();
        });
    },

    async getTokenBalance(context) {
        if (!context.state.address) {
            return "";
        }

        try {
            let token = context.state.tokens.find(
                item =>
                    item.symbol == context.state.selectedToken &&
                    item.network == context.state.selectedNetwork
            );
            const tokenContract = new context.state.activeWeb3.eth.Contract(
                token.abi,
                token.contract
            );

            const balance = await tokenContract.methods
                .balanceOf(context.state.address)
                .call();
            Decimal.set({ precision: 50, defaults: true });
            this.commit(
                "wallet/setBalance",
                new Decimal(balance).dividedBy(token.decimals).toString()
            );
        } catch (error) {
            console.log(error);
        }
    },

    async addToken(context, { token }) {
        // if (typeof window.ethereum === "undefined") {
        //   return;
        // }

        const tokenAddress = token.contract;
        const tokenSymbol = token.symbol;
        const tokenDecimals = 18;
        const tokenImage = "";

        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await ethereum.request({
                method: "metamask_watchAsset",
                params: {
                    type: "ERC20", // Initially only supports ERC20, but eventually more!
                    options: {
                        address: tokenAddress, // The address that the token is at.
                        symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
                        decimals: tokenDecimals, // The number of decimals in the token
                        image: tokenImage // A string url of the token logo
                    }
                }
            });

            if (wasAdded) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },

    async checkToken(context, { vault_contract, token }) {
        try {
            const tokenContract = new this.state.vaults.web3.eth.Contract(
                token.abi,
                token.contract
            );

            const approved = await tokenContract.methods
                .balanceOf(context.state.address)
                .call({
                    from: context.state.address,
                    gas: "250000" // customizable by user during MetaMask confirmation.
                });

            return approved;
        } catch (error) {
            console.log(error);
        }
    }
};

const mutations = {
    setChainId(state, chainId) {
        if (state.chainId == chainId) return;
        state.chainId = chainId;
        localStorage.setItem("chainId", chainId);
    },

    setSelectedNetwork(state, payload) {
        // modify here if tokenText != selectedNetwork
        state.tokenText = payload.selectedTokenText
            ? payload.selectedTokenText
            : payload.selectedNetwork;
        state.selectedNetwork = payload.selectedNetwork;
    },

    setSelectedToken(state, { token, network }) {
        state.selectedToken = token;
        state.selectedNetwork = network;

        this.dispatch("wallet/getTokenBalance");
    },

    setCurrentNetwork(state, currentNetwork) {
        state.currentNetwork = currentNetwork;
    },

    setHasWallet(state, hasWallet) {
        state.hasWallet = hasWallet;
        localStorage.setItem("hasWallet", hasWallet);
    },

    setWalletProvider(state, value) {
        state.walletProvider = value;
        localStorage.setItem("walletProvider", value);
        if (value == "metamask") {
            const metamaskWeb3 = new Web3(
                Web3.givenProvider || "ws://localhost:8545"
            );
            state.activeWeb3 = metamaskWeb3;
        } else if (value == "walletconnect") {
            const walletConnectWeb3 = new Web3(walletConnectProvider);
            state.activeWeb3 = walletConnectWeb3;
        } else {
            state.activeWeb3 = null;
        }
    },

    setDisconnectingWalletConnect(state, status) {
        state.disconnectingWalletConnect = status;
    },

    setCheckMetamask(state, checkMetamask) {
        state.checkMetamask = checkMetamask;
    },

    setBalance(state, balance) {
        state.balance = balance;
        localStorage.setItem("balance", balance);
    },

    setBaseBalance(state, balance) {
        state.baseBalance = balance;
        localStorage.setItem("baseBalance", balance);
    },

    setAddress(state, address) {
        state.address = address;
        localStorage.setItem("address", address);
        let slicedAddress = address
            ? address.slice(0, 6) + "..." + address.slice(-4)
            : null;
        state.slicedAddress = slicedAddress;
        localStorage.setItem("slicedAddress", slicedAddress);
    },

    setTokens(state, tokens) {
        state.tokens = tokens;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
